import { render, staticRenderFns } from "./Recomendacao.vue?vue&type=template&id=af6e997a&scoped=true"
import script from "./Recomendacao.vue?vue&type=script&lang=js"
export * from "./Recomendacao.vue?vue&type=script&lang=js"
import style0 from "./Recomendacao.vue?vue&type=style&index=0&id=af6e997a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af6e997a",
  null
  
)

export default component.exports